import Alpine from "alpinejs";
window.Alpine = Alpine;
import '../sass/main.scss';
import "./search.js";
import {registerAuthComponents} from "./accounts/components/auth/index.js";
import {registerMyAccountComponents} from "./accounts/components/my-account/index.js";
import {registerResourceComponents} from "./accounts/components/resources/index.js";

import.meta.glob('./*.js', {
    eager: true,
});

registerAuthComponents();
registerMyAccountComponents();
registerResourceComponents();

// Start Alpine
Alpine.start();

(() => {
    /**
     * Reload the page with new query parameters, stripping out any existing ones
     * @param {Object.<string, string>} params - A key/value object of query parameters
     */
    function reloadPageWithParams(params) {
        const url = new URL(window.location.href);
        url.search = new URLSearchParams(params);
        window.location.href = url.href;
    }

    /**
     * EventIndexPage - Duet Date Picker: Single
     */
    const DATE_PICKER_ELEM = document.querySelector('duet-date-picker#event-date-picker');
    if (DATE_PICKER_ELEM) {
        DATE_PICKER_ELEM.addEventListener('duetChange', (e) => {
            const date = e.detail.value;
            reloadPageWithParams({date});
        });
    }

    /**
     * EventIndexPage - Duet Date Picker: Ranges
     */
    const START_PICKER_ELEM = document.querySelector("#event-date-picker__start");
    const END_PICKER_ELEM = document.querySelector("#event-date-picker__end");

    if (START_PICKER_ELEM && END_PICKER_ELEM) {
        let start_date = START_PICKER_ELEM.value || null;
        let end_date = END_PICKER_ELEM.value || null;

        // Set START_PICKER_ELEM's max date and END_PICKER_ELEM's min date
        if (start_date && Date.parse(end_date)) {
            START_PICKER_ELEM.max = end_date;
        }
        if (end_date && Date.parse(start_date)) {
            END_PICKER_ELEM.min = start_date;
        }

        /**
         * Callback function for when a date is selected in one of the date range pickers.
         * Keeps both picker's min/max values in sync, and reloads the page when a new, valid date range is selected.
         * @param {object} event - The event listener's event object
         * @param {bool} is_start_date - Whether the current date picker element is the start date picker
         */
        function handleDateChange(event, is_start_date) {
            const new_date = event.detail.value;
            if (!new_date) return;

            if (is_start_date) {
                if (new_date === start_date) return;
                start_date = new_date;
                END_PICKER_ELEM.min = start_date;
            } else {
                if (new_date === end_date) return;
                end_date = new_date;
                START_PICKER_ELEM.max = end_date;
            }

            if (start_date && end_date) {
                reloadPageWithParams({start_date, end_date});
            } else {
                (is_start_date ? END_PICKER_ELEM : START_PICKER_ELEM).show();
            }
        }

        START_PICKER_ELEM.addEventListener("duetChange", (event) => handleDateChange(event, true));
        END_PICKER_ELEM.addEventListener("duetChange", (event) => handleDateChange(event, false));
    }
})();

document.addEventListener('DOMContentLoaded', () => {
    const rangeInput = document.querySelector('#duration');
    const valueDisplay = document.querySelector('#duration-value');

    if (!rangeInput || !valueDisplay) return;

    const updateValue = () => {
        valueDisplay.textContent = rangeInput.value;
    };

    rangeInput.addEventListener('input', updateValue);

    // Set initial value on load
    updateValue();
});